module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-BlackItalic-61c26de83fc134003d3fab84051499e2.woff2";